export default "__VITE_ASSET__DDTHs_IP__"